export default __webpack_public_path__ + "static/media/datepicker.6c0eee83.svg";